import BaseClient from './BaseClient';

class MeClient extends BaseClient {
    update(data) {
        const url = `/api/v3/me`;
        return this.makeCoreApiRequest(url, 'put', data);
    }
}

export default new MeClient();
